import { CheckIcon, CloseIcon } from '@mantine/core';
import { notifications, type NotificationData } from '@mantine/notifications';

export const showNotification = (notification: NotificationData) =>
  notifications.show(notification);

export const updateNotification = (notification: NotificationData) =>
  notifications.update(notification);

export const showLoadingNotification = ({ id }: { id: string }) =>
  showNotification({
    id,
    loading: true,
    title: 'Loading...',
    message: 'We will update you shortly.',
    autoClose: false,
    radius: 10,
  });

export const hideNotification = ({ id }: { id: string }) =>
  notifications.hide(id);

export const showErrorNotification: typeof showNotification = ({
  title,
  message,
  ...props
}) =>
  showNotification({
    title,
    message,
    color: 'red',
    icon: <CloseIcon />,
    radius: 10,
    // Errors stay visible until the user closes them.
    autoClose: false,
    className: 'success-notification',
    ...props,
  });

export const updateWarnNotification = ({
  title,
  message,
  id,
  ...props
}: NotificationData & { id: string }) =>
  updateNotification({
    id,
    title,
    message,
    color: 'yellow',
    autoClose: 3000,
    radius: 10,
    icon: null,
    loading: false,
    ...props,
  });

export const showWarnNotification: typeof showNotification = ({
  title,
  message,
  ...props
}) =>
  showNotification({
    title,
    message,
    color: 'yellow',
    autoClose: 3000,
    radius: 10,
    ...props,
  });

export const updateErrorNotification = ({
  title,
  message,
  id,
  ...props
}: NotificationData & { id: string }) =>
  updateNotification({
    title,
    message,
    color: 'red',
    icon: <CloseIcon />,
    radius: 10,
    loading: false,
    autoClose: false,
    ...props,
    id,
  });

export const showSuccessNotification: typeof showNotification = ({
  title,
  message,
  ...props
}) =>
  showNotification({
    title,
    message,
    color: 'teal',
    icon: <CheckIcon size={14} />,
    radius: 10,
    autoClose: 3000,
    id: 'success-notification',
    classNames: {
      body: 'success-notification-body',
    },
    ...props,
  });

export const updateSuccessNotification = ({
  title,
  message,
  ...props
}: NotificationData & { id: string }) =>
  updateNotification({
    title,
    message,
    color: 'teal',
    icon: <CheckIcon size={14} />,
    radius: 10,
    classNames: {
      body: 'success-notification-body',
    },
    loading: false,
    autoClose: 3000,
    ...props,
  });
